<template>
    <v-navigation-drawer stateless value="true" class="catalog-navigation">
        <v-toolbar text color="white">
            <v-toolbar-title>
                <v-text-field
                    label="Поиск"
                    solo
                    text
                    single-line
                    class="mb-0"
                    prepend-icon="search"
                    hide-details/>
            </v-toolbar-title>
            <v-spacer/>
            <v-menu bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="addPush">
                        <v-list-item-title>Добавить</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-list v-if="getPushes.length > 0" class="v-list--booking">
            <v-list-item
                :key="push.id"
                @click="editPush(push.id)"
                v-for="push in getPushes"
                :class="`v-list--booking_state f-width ${$route.params.pushId === push.id ? 'active' : ''}`">
                <v-list-item-title v-text="push.title"/>
                <v-list-item-action>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon @click.prevent="PushChangeState(push.id, push.status)" v-on="on">
                                <v-icon>{{ push.status ? 'remove_red_eye' : 'visibility_off' }}</v-icon>
                            </v-btn>
                        </template>
                        <span>Статус</span>
                    </v-tooltip>
                </v-list-item-action>
            </v-list-item>
        </v-list>
        <empty v-else/>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Push from '../../../api/push'
    import Empty from '../../../components/Loader/Empty'

    export default {
        name: 'pushNavigation',
        components: { Empty },
        methods: {
            addPush () {
                this.$router.push({ name: 'addPush' })
            },
            editPush (id) {
                this.$router.push({
                    name: 'viewPush',
                    params: { pushId: id }
                })
            },
            PushChangeState (id, status) {
                Push
                    .changeStatus({
                        id,
                        status
                    })
                    .then(response => {
                        this.$store.commit('pushChangeState', response.data.data)
                        this.$store.commit('showSnackbar', {
                            text: 'Статус пуша изменен успешно',
                            color: 'info'
                        })
                    })
                    .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
            }
        },
        computed: mapGetters([
            'getPushes'
        ])
    }
</script>
